import { ADD_USER_FAILURE, ADD_USER_REQUEST, ADD_USER_SUCCESS } from '../constants/add_user.constants';
import { INVITE_USER_DATA_REQUEST, INVITE_USER_DATA_REQUEST_SUCCESS, INVITE_USER_DATA_REQUEST_FAILURE } from '../constants/invite_user_data.constants';

const initialState = {
    User_create_table: {
        isAdded: false,
        loading: false,
        options: null,
        error: null,
    },
};

export const User_create = (state = initialState, action) => {
    switch (action.type) {
    case ADD_USER_REQUEST:
        return {
            ...state,
            User_create_table: {
                ...state.User_create_table,
                isAdded: true,
            },
        };
    case INVITE_USER_DATA_REQUEST:
        return {
            ...state,
            User_create_table: {
                ...state.User_create_table,
                loading: true,
            },
        };
    case INVITE_USER_DATA_REQUEST_SUCCESS:
        return {
            ...state,
            User_create_table: {
                ...state.User_create_table,
                options: action.payload,
                loading: false,
            },
        };
    case ADD_USER_SUCCESS:
        return {
            ...state,
            User_create_table: {
                ...state.User_create_table,
                isAdded: false,
            },
        };
    case ADD_USER_FAILURE:
        return {
            ...state,
            User_create_table: {
                ...state.User_create_table,
                error: action.error,
            },
        };
    case INVITE_USER_DATA_REQUEST_FAILURE:
        return {
            ...state,
            User_create_table: {
                ...state.User_create_table,
                error: action.error,
                loading: false,
            },
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/reducers/add_user.reducer.js